import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["summary", "status", "button", "icon"]
  static values = { url: String }

  async generate(event) {
    event?.preventDefault?.()

    if (!this.hasUrlValue || !this.urlValue) return
    if (!this.hasSummaryTarget) return

    const currentSummary = (this.summaryTarget.value || "").toString().trim()
    if (currentSummary !== "") {
      const ok = window.confirm("Replace the existing Summary?")
      if (!ok) return
    }

    const body = this._readBodyFromForm()

    this._setBusy(true)
    this._setStatus("")

    try {
      const res = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-CSRF-Token": this._csrfToken(),
        },
        body: JSON.stringify({ body }),
      })

      const data = await res.json().catch(() => ({}))
      if (!res.ok) {
        const msg = (data && data.error) ? data.error : `HTTP ${res.status}`
        throw new Error(msg)
      }

      const summary = (data && data.summary) ? data.summary.toString() : ""
      this.summaryTarget.value = summary
      this._setStatus("")
    } catch (e) {
      this._setStatus(`Error: ${e?.message || "failed"}`)
    } finally {
      this._setBusy(false)
      // Clear transient status after a moment (unless it's an error).
      this._clearStatusSoon()
    }
  }

  _csrfToken() {
    return document
      .querySelector("meta[name='csrf-token']")
      ?.getAttribute("content")
      ?.toString() || ""
  }

  _readBodyFromForm() {
    // Milkdown keeps the underlying textarea in sync, and that's our source of truth.
    const form = this.element.closest("form")
    const el = form?.querySelector?.('textarea[name="page[body]"]')
    return (el?.value || "").toString()
  }

  _setBusy(isBusy) {
    const busy = !!isBusy
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = busy
      this.buttonTarget.setAttribute("aria-busy", busy ? "true" : "false")
    }
    if (this.hasSummaryTarget) {
      this.summaryTarget.readOnly = busy
      this.summaryTarget.setAttribute("aria-busy", busy ? "true" : "false")
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("fa-wand-magic-sparkles", !busy)
      this.iconTarget.classList.toggle("fa-spinner", busy)
      this.iconTarget.classList.toggle("fa-spin", busy)
    }
  }

  _setStatus(text) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = (text || "").toString()
  }

  _clearStatusSoon() {
    if (!this.hasStatusTarget) return
    const text = (this.statusTarget.textContent || "").toString()
    if (text.startsWith("Error:")) return
    if (text === "") return
    clearTimeout(this._statusTimer)
    this._statusTimer = setTimeout(() => {
      this._setStatus("")
    }, 1500)
  }
}
